import {Cloneable} from "@/common/Cloneable";
import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Schema} from "@/common/Schema";

export class CurenciesModel extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(CurenciesModel, v) : SKIP;
            },
            (v) => {
                return deserialize(CurenciesModel, v);
            }
        );
    }

    constructor() {
        super();
        this._kind = 0;
        this._amount = 0;
        this._capacity = 0;
    }

    get kind() {
        return this._kind;
    }
    set kind(value) {
        this._kind = value;
    }

    get amount() {
        return this._amount;
    }
    set amount(value) {
        this._amount = value;
    }

    get capacity() {
        return this._capacity;
    }
    set capacity(value) {
        this._capacity = value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CurenciesModel());
        } else if (target instanceof CurenciesModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CurenciesModel, {
    _kind: alias("kind", Schema.primitive()),
    _amount: alias("amount", Schema.primitive()),
    _capacity: alias("capacity", Schema.primitive()),
});
